import { useState, useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getQuote, type Quote } from '../lib/api'
import { QuoteDetail } from '../components/QuoteDetail'

export const QuotePage = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [quote, setQuote] = useState<Quote | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    if (!id) return
    try {
      setIsLoading(true)
      const res = await getQuote(Number(id))
      setQuote(res.data)
    } catch (err: unknown) {
      const status = (err as { response?: { status?: number } }).response?.status
      if (status === 404) {
        setError('Zitat nicht gefunden.')
      } else {
        console.error('Fehler beim Laden des Zitats:', err)
        setError('Zitat konnte nicht geladen werden (Serverfehler).')
      }
    } finally {
      setIsLoading(false)
    }
  }, [id])

  useEffect(() => { load() }, [load])

  if (isLoading) return <p>Wird geladen…</p>
  if (error || !quote) return (
    <div>
      <p>{error ?? 'Zitat nicht gefunden.'}</p>
      <button onClick={() => navigate('/')}>Zurück</button>
    </div>
  )

  return <QuoteDetail quote={quote} onUpdate={load} />
}
